import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

/**
 * Redirects the legacy `/ad-details?id=<id>` deep link to the canonical
 * SEO-friendly path route `/ads/space-rental/<id>`. If no `id` query param is
 * present, sends the user to the ad listing instead of an empty detail page.
 *
 * Returning a `UrlTree` makes the router perform a navigation (which results in
 * a client-side route change). This guard exists for backwards compatibility
 * with old bookmarks and external links; new code should link to the clean path
 * directly.
 */
export const adDetailsRedirectGuard: CanActivateFn = route => {
	const router = inject(Router)
	const id = route.queryParamMap.get('id')

	if (id) {
		return router.parseUrl(`/ads/space-rental/${id}`)
	}
	return router.parseUrl('/ads-list')
}
